import '../App.css';
import '../css/Nav design.css';


function Offeradd() {
  return (
    <div className="container mt-2 mb-5 ">
      <div className="offer-banner  p-0">

        <label className="offer-title ">
          🎉 Launch Membership Offer 🎉
        </label>

        <p className="offer-subtitle">
          Register Now & Get Free Premium Access
        </p>

        <div className="divider mt-3"></div>

        <div className="row mt-4 justify-content-center">

          <div className="col-lg-4 col-md-6 col-12 mb-3 d-flex justify-content-center">
            <div className="offer-box p-2 w-100" style={{ maxWidth: "250px" }}>
              <h5 className="year red">1 Year</h5>
              <p>First 1,000 Users</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-12 mb-3 d-flex justify-content-center">
            <div className="offer-box p-2 w-100" style={{ maxWidth: "250px" }}>
              <h5 className="year pink">6 Months</h5>
              <p>Users 1,001 – 1,500</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-12 mb-3 d-flex justify-content-center">
            <div className="offer-box p-2 w-100" style={{ maxWidth: "250px" }}>
              <h5 className="year purple">3 Months</h5>
              <p>Users 1,501 – 2,000</p>
            </div>
          </div>

        </div>

        <div className="offer-note mt-1">
          ⭐ Offer available for a limited number of registrations.
        </div>

      </div>
    </div>
  );
}

export default Offeradd;